import { ref, onMounted, onUnmounted, watch } from '@vue/composition-api'
import { chatUseCase } from '../usecases'
import useRouter from './useRouter'

const useRooms = () => {
    const room = ref({})
    const rooms = ref(null)
    const { route, router } = useRouter()
    let detachRoomsListener = () => {}

    onMounted(() => {
        detachRoomsListener = chatUseCase.getRooms(
            (newRooms) => {
                if(!newRooms) return
                rooms.value = newRooms
                const currentRoom = newRooms.find(item => item.id === route.value.query.roomId)
                if(currentRoom && currentRoom.lastMessage && room.value){
                    room.value.lastMessage = currentRoom.lastMessage
                }
            }
        )
    })

    onUnmounted(() => {
        detachRoomsListener()
    })

    // room change handler
    watch([route], ([route]) => {
        const roomId = route.query.roomId
        if (!roomId) {
            return
        }

        room.value = {}

        chatUseCase
            .getRoom(roomId)
            .then(
                (r) => {
                    room.value = r
                }
            )
    }, { immediate: true })

    // preselect
    watch(rooms, async rooms => {
        const activeRoom = route.value.query.roomId
        if (activeRoom) {
            return
        }

        const campaigns = route.value.query.campaigns
        if (campaigns) {
            let existingRoom = rooms.find(
                (room) => room.campaigns.includes(`${campaigns[0]}_${campaigns[1]}`)
            )

            if (!existingRoom) {
                // create new room and store it in existingRoom
                existingRoom = await chatUseCase.createRoom(campaigns)

                if(!existingRoom){
                    return
                }
            }

            return router.push({
                name: 'chat',
                query: {
                    roomId: existingRoom.id,
                    message: route.value.query.message,
                }
            }).catch(() => {})
        }

        // select last item
        const latestRoom = rooms[0]
        if (latestRoom) {
            return router.push({
                name: 'chat',
                query: {
                    roomId: latestRoom.id
                }
            }).catch(() => {})
        }
    })

    return {
        rooms,
        room,
    }
}

export default useRooms